import { Box } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';

/**
 * Hover hint for a trigger form field.
 *
 * FieldToolTip renders its icon in the normal flow, so mounting it on hover
 * reflowed the row it sat in — the field narrowed and everything below it
 * shifted (2948). Anchoring it to the right edge of the (relatively
 * positioned) FormControl keeps it out of the flow, so showing and hiding it
 * costs no layout.
 */
const TriggerFieldToolTip = ({ isVisible, label, ariaLabel }) =>
    isVisible ? (
        <Box position="absolute" right="0" top="20px">
            <FieldToolTip label={label} ariaLabel={ariaLabel} />
        </Box>
    ) : null;

export default TriggerFieldToolTip;
